import React, { useState } from 'react';
import { ThesisHistoryEntry } from '../../../ai/thesisEngine';

export function ThesisTriggerHistory({ entry }: { entry: ThesisHistoryEntry }) {
  const [expanded, setExpanded] = useState(false);
  const biasColor = entry.bias === 'bullish' ? 'var(--green)' : entry.bias === 'bearish' ? 'var(--red)' : 'var(--amber)';
  const changeColor = entry.thesisChange === 'invalidated' ? 'var(--red)'
    : entry.thesisChange === 'strengthened' ? 'var(--green)'
    : entry.thesisChange === 'weakened' ? 'var(--amber)'
    : entry.thesisChange === 'new' ? 'var(--cyan)'
    : 'var(--border)';
  const ageMin = Math.round((Date.now() - entry.timestamp) / 60000);
  return (
    <div style={{ borderRadius: 4, marginBottom: 4, overflow: 'hidden',
      border: `1px solid ${expanded ? changeColor + '44' : 'var(--border)'}`,
      borderLeft: `2px solid ${changeColor}` }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer',
        padding: '7px 9px', background: 'var(--surface)' }}
        onClick={() => setExpanded(!expanded)}>
        <span style={{ fontSize: 9, color: 'var(--blue-dim)', fontFamily: 'var(--mono)', minWidth: 32, flexShrink: 0 }}>{ageMin}m</span>
        <span style={{ fontSize: 9, fontFamily: 'var(--mono)', fontWeight: 700, color: changeColor,
          border: `1px solid ${changeColor}44`, padding: '0 4px', borderRadius: 2, flexShrink: 0 }}>
          {entry.thesisChange.toUpperCase()}
        </span>
        <span style={{ flex: 1, fontSize: 10, color: 'var(--blue-muted)', lineHeight: 1.3,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {entry.summary}
        </span>
        <span style={{ fontSize: 12, fontWeight: 700, color: biasColor, fontFamily: 'var(--mono)', flexShrink: 0 }}>{entry.conviction}%</span>
        <span style={{ fontSize: 9, color: 'var(--blue-dim)', flexShrink: 0 }}>{expanded ? '▲' : '▼'}</span>
      </div>
      {expanded && (
        <div style={{ padding: '8px 10px', background: 'var(--surface2)', borderTop: `1px solid ${changeColor}22` }}>
          <div style={{ fontSize: 9, fontFamily: 'var(--mono)', color: 'var(--blue-dim)', marginBottom: 3 }}>
            {new Date(entry.timestamp).toLocaleTimeString()} · {entry.bias.toUpperCase()} {entry.marketState} · {entry.actionability}% actionable
          </div>
          <div style={{ fontSize: 10, color: 'var(--t1)', lineHeight: 1.6 }}>
            {entry.summary.replace(/^[↑↓→★⚠].*?\| /, '')}
          </div>
          {entry.inputHash && (
            <div style={{ fontSize: 8, color: 'var(--blue-dim)', fontFamily: 'var(--mono)', marginTop: 4 }}>
              hash: {entry.inputHash}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
